// src/contexts/NotificationContext.js
import React, { createContext, useContext, useState } from 'react';
import CustomNotification from '../components/CustomNotification'; // Importe o componente renomeado

const NotificationContext = createContext();

export function NotificationProvider({ children }) {
  const [notification, setNotification] = useState(null);

  const showNotification = (message, type) => {
    setNotification({
      message,
      type,
      onClose: () => setNotification(null),
    });
    setTimeout(() => setNotification(null), 5000); // Notificação desaparece após 5 segundos
  };

  return (
    <NotificationContext.Provider value={{ addNotification: showNotification }}>
      {notification && (
        <CustomNotification
          message={notification.message}
          type={notification.type}
          onClose={notification.onClose}
        />
      )}
      {children}
    </NotificationContext.Provider>
  );
}

export const useNotification = () => useContext(NotificationContext);
